interface BuildingArea {
    total: string;
}

interface SiteArea {
    sqFt: string;
}

export interface SalientFactsData {
    county: string;
    dateOfValue: string;
    taxesPayableYear: string;
    jurisdiction: string;
    propertyType: string;
    numberOfBuildings: string;
    buildingArea: BuildingArea;
    yearBuilt: string;
    siteArea: SiteArea;
    buildable: string;
    parcelNumber: string;
    referenceNumber: string;
}

export interface EditSalientFactsProps {
    open: boolean;
    onClose: () => void;
    immutableInitialData: any;
}

export interface SalientFactsProps {
    data: any;
}

export interface FieldConfig {
    label: string;
    field: string;
    type?: string;
    unit?: string;
    placeholder?: string;
    nested?: {
        parent: "buildingArea" | "siteArea";
        field: string;
    };
}

export const DEFAULT_SALIENT_FACTS: SalientFactsData = {
    county: "",
    dateOfValue: "",
    taxesPayableYear: "",
    jurisdiction: "",
    propertyType: "",
    numberOfBuildings: "",
    buildingArea: { total: "" },
    yearBuilt: "",
    siteArea: { sqFt: "" },
    buildable: "",
    parcelNumber: "",
    referenceNumber: "",
};
